import React from "react";
import { Box, Typography, Skeleton, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useNbaTopPlayers } from "../../hooks/useNbaTopPlayers";
import PlayerHeadshot from "../PlayerHeadshot";
import HomeSection from "./HomeSection";
import { homeCardHover, horizontalScroll } from "./homeStyles";
import { colors } from "../../theme";

const NbaHotPlayerCard = ({ player, onClick }) => {
  const points = player.points ?? "–";
  const position = player.position;

  return (
    <Box
      onClick={onClick}
      sx={{
        minWidth: 140,
        maxWidth: 140,
        flex: "0 0 auto",
        p: 1.5,
        borderRadius: 1.5,
        border: `1px solid ${colors.border}`,
        ...homeCardHover,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <PlayerHeadshot
          playerId={player.playerId}
          sport="nba"
          size={56}
          showTooltip={false}
          showLoading={false}
        />
      </Box>
      <Typography variant="body2" fontWeight={600} noWrap textAlign="center" title={player.name}>
        {player.name}
      </Typography>
      {position && (
        <Typography variant="caption" color="text.secondary" noWrap display="block" textAlign="center">
          {position}
        </Typography>
      )}
      <Box sx={{ mt: 1, textAlign: "center" }}>
        <Typography variant="caption" color="text.secondary">
          Career PTS
        </Typography>
        <Typography variant="h6" fontWeight={700} color="primary.main" lineHeight={1.2}>
          {Number(points).toLocaleString()}
        </Typography>
      </Box>
    </Box>
  );
};

const NbaHotPlayersRow = () => {
  const navigate = useNavigate();
  const { topPlayers, isLoading, error } = useNbaTopPlayers("points");

  return (
    <HomeSection
      title="All-time scoring leaders"
      subtitle="Tap a legend to open their profile"
      noPadding
    >
      <Box sx={{ p: 2 }}>
        {isLoading && (
          <Box sx={horizontalScroll}>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} variant="rounded" width={140} height={160} sx={{ flexShrink: 0 }} />
            ))}
          </Box>
        )}

        {error && (
          <Alert severity="warning">Could not load top scorers</Alert>
        )}

        {!isLoading && !error && topPlayers.length === 0 && (
          <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
            No player data available
          </Typography>
        )}

        {!isLoading && !error && topPlayers.length > 0 && (
          <Box sx={horizontalScroll}>
            {topPlayers.map((player) => (
              <NbaHotPlayerCard
                key={player.playerId}
                player={player}
                onClick={() => navigate(`/app/nba/player/${player.playerId}`)}
              />
            ))}
          </Box>
        )}
      </Box>
    </HomeSection>
  );
};

export default NbaHotPlayersRow;
